import { Tables } from "@/lib/supabase/supabase_types_override";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useGetCrmProjectsByCrmId(crmId: Tables<'crm'>['id'] | undefined) {
    return useQuery({
      ...queryKeys.crm_project.list._ctx.byCrmId(crmId!),
      enabled: !!crmId
    })
  }